import axios from 'axios';
import { request, parseError } from '../../../helpers/requests';

const ExternalFormService = {
  getAllPhases: (templateId) => request({
    call: axios.get(`external/${templateId}/phases`),
    errMsg: parseError('Failed to get phases'),
    hideSuccessToast: true,
  }),
  getAllCostcodes: (templateId) => request({
    call: axios.get(`external/${templateId}/costcodes`),
    errMsg: parseError('Failed to get costcodes'),
    hideSuccessToast: true,
  }),
  getAllProjects: (templateId) => request({
    call: axios.get(`external/${templateId}/projects`),
    errMsg: parseError('Failed to get projects'),
    hideSuccessToast: true,
  }),
  getAllVendors: (templateId) => request({
    call: axios.get(`external/${templateId}/vendors`),
    errMsg: parseError('Failed to get vendors'),
    hideSuccessToast: true,
  }),
  getAllCustomers: (templateId) => request({
    call: axios.get(`external/${templateId}/customers`),
    errMsg: parseError('Failed to get customers'),
    hideSuccessToast: true,
  }),
  getAllUsers: (templateId) => request({
    call: axios.get(`external/${templateId}/users`),
    errMsg: parseError('Failed to get users'),
    hideSuccessToast: true,
  }),
  getAllEquipment: (templateId) => request({
    call: axios.get(`external/${templateId}/equipment`),
    errMsg: parseError('Failed to get equipment'),
    hideSuccessToast: true,
  }),
  getProjectEquipment: (templateId) => request({
    call: axios.get(`external/${templateId}/projectEquipment`),
    errMsg: parseError('Failed to get project equipment'),
    hideSuccessToast: true,
  }),
  getAllScheduleOfValues: (templateId) => request({
    call: axios.get(`external/${templateId}/scheduleOfValues`),
    errMsg: parseError('Failed to get schedule of values'),
    hideSuccessToast: true,
  }),
  getAllScheduleOfValueSections: (templateId) => request({
    call: axios.get(`external/${templateId}/scheduleOfValueSections`),
    errMsg: parseError('Failed to get schedule of value sections'),
    hideSuccessToast: true,
  }),
  getLabels: (templateId) => request({
    call: axios.get(`external/${templateId}/labels`),
    errMsg: parseError('Failed to get labels'),
    hideSuccessToast: true,
  }),
  getLightWeightForms: (templateId, query) => request({
    call: axios.get(`external/${templateId}/forms/lightweight`, { params: query }),
    errMsg: parseError('Failed to get lightweight forms'),
    hideSuccessToast: true,
  }),
  getContacts: (templateId) => request({
    call: axios.get(`external/${templateId}/contacts`),
    errMsg: parseError('Failed to get contacts'),
    hideSuccessToast: true,
  }),
  getBuckets: (templateId, query) => request({
    call: axios.get(`external/${templateId}/buckets`, { params: query }),
    errMsg: parseError('Failed to get buckets'),
    hideSuccessToast: true,
  }),
};

export default ExternalFormService;
